import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { faEye, faFilter } from '@fortawesome/free-solid-svg-icons';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { updateFormFilter, updateTypeFilter } from '../../store/actions/form.actions';
import { getFormFilters, getFormTypeFilters } from '../../store/selectors/form.selector';
import { FormsState } from '../../store/state/pace-forms.state';
import { FormFilter } from '../../types/form-filter';
import { TypeFilter } from '../../types/type-filter';

@Component({
    selector: 'pace-forms-type-filter',
    templateUrl: './filter.component.html',
    styleUrls: ['./filter.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class FilterComponent {
    public typeFilterItems$: Observable<TypeFilter[]>;
    public formFilterItem$: Observable<FormFilter[]>;

    public faEye = faEye;
    public constructor(
        private readonly store: Store<FormsState>,
        private readonly cdr: ChangeDetectorRef,
    ) {
        this.typeFilterItems$ = this.store
            .select(getFormTypeFilters)
            .pipe(map((typeFilters) => Object.values(typeFilters).filter((f) => f.active)));
        this.formFilterItem$ = this.store.select(getFormFilters).pipe(map((formFilters) => Object.values(formFilters)));
    }

    public onTypeFilterSelected(event: Event, entry: TypeFilter): void {
        if (event) {
            event.stopPropagation();
        }
        this.store.dispatch(
            updateTypeFilter({
                elementType: entry.elementType,
                visible: !entry.visible,
            }),
        );
        this.cdr.detectChanges();
    }

    public onFormFilterSelected(event: Event, entry: FormFilter): void {
        if (event) {
            event.stopPropagation();
        }
        this.store.dispatch(
            updateFormFilter({
                filterType: entry.filterType,
                visible: !entry.visible,
            }),
        );
        this.cdr.detectChanges();
    }

    protected readonly faFilter = faFilter;
}
